import classnames from 'classnames'
import { FC, HTMLAttributes } from 'react'

const Placeholder: FC<HTMLAttributes<HTMLDivElement>> = ({ className, ...props }) => (
  <div className={classnames('placeholder', className)} {...props} />
)

export default Placeholder
